import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { Markup } from 'interweave';
import './../styles/index.css';

export default function ConfirmBox(props) {

    const [show, setShow] = useState(false);
    const { selectConfirm } = props; //to pass callback

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }

    const submit = () => {
        setShow(false);
        selectConfirm(props.option);
    }

    return (
        <div>
            <Button className="bottomButton2" onClick={handleShow}>
                {props.button}
            </Button>


            <Modal show={show} onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="my-modal"

            >
                <Modal.Header closeButton closeVariant="white" >
                    <Modal.Title>{props.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body><Markup content={props.content} />
                    <br /><br />
                    <div className="text-end">
                        <Button className="yesnoButton" onClick={handleClose}>
                            No
                        </Button>
                        <Button className="yesnoButton" onClick={submit}>
                            Yes
                        </Button>
                    </div>
                </Modal.Body>

            </Modal>
        </div>
    );


}
